/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectChangesSettingsControllerRemoveAutomaticPrimeContractMutationResponse, ProjectChangesSettingsControllerRemoveAutomaticPrimeContractPathParams, ProjectChangesSettingsControllerRemoveAutomaticPrimeContract401, ProjectChangesSettingsControllerRemoveAutomaticPrimeContract403, ProjectChangesSettingsControllerRemoveAutomaticPrimeContract404 } from "../../models/changeOrdersController/ProjectChangesSettingsControllerRemoveAutomaticPrimeContract";

function getProjectChangesSettingsControllerRemoveAutomaticPrimeContractUrl(projectId: ProjectChangesSettingsControllerRemoveAutomaticPrimeContractPathParams["projectId"]) {
  const res = { method: 'DELETE', url: `/api/v1/project-changes-settings/${projectId}/automatic-prime-contract` as const }  
  return res
}

/**
 * @summary Remove the automatically selected prime contract
 * {@link /api/v1/project-changes-settings/:projectId/automatic-prime-contract}
 */
export async function projectChangesSettingsControllerRemoveAutomaticPrimeContract(projectId: ProjectChangesSettingsControllerRemoveAutomaticPrimeContractPathParams["projectId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectChangesSettingsControllerRemoveAutomaticPrimeContractMutationResponse, ResponseErrorConfig<ProjectChangesSettingsControllerRemoveAutomaticPrimeContract401 | ProjectChangesSettingsControllerRemoveAutomaticPrimeContract403 | ProjectChangesSettingsControllerRemoveAutomaticPrimeContract404>, unknown>({ method : "DELETE", url : getProjectChangesSettingsControllerRemoveAutomaticPrimeContractUrl(projectId).url.toString(), ... requestConfig })  
  return res.data
}